import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 2,
      refetchOnWindowFocus: true,
    },
  },
});
export default queryClient;
